import BottomNav from './BottomNav';

export default function AppLayout() {
  return (
    <div className="pb-app-bottom-nav">
      <Outlet />
      <BottomNav />
    </div>
  );
}
